import type { FollowUpItem, FollowUpView } from '@/types'

/** The three follow-up views on the reps' dashboard, in display order. */
export const FOLLOW_UP_VIEWS: {
  key: FollowUpView
  label: string
  hint: string
  empty: (noun: string) => string
}[] = [
  {
    key: 'stale_no_next',
    label: 'Stale, nothing scheduled',
    hint: 'No activity in 90+ days and nothing planned. Start here.',
    empty: (noun) => `No ${noun} are both quiet and unplanned`,
  },
  {
    key: 'no_next_step',
    label: 'Nothing scheduled',
    hint: 'No open task (or one more than 30 days overdue) and no upcoming meeting.',
    empty: (noun) => `Every one of your ${noun} has a next step`,
  },
  {
    key: 'stale',
    label: 'No contact in 90+ days',
    hint: 'No completed task, meeting, call or email in 90+ days.',
    empty: (noun) => `All ${noun} have had contact in the last 90 days`,
  },
]

/** "118 days quiet" / "never contacted" */
export function quietLabel(item: FollowUpItem): string {
  if (!item.ever_active) return 'never contacted'
  if (item.days_quiet == null) return ''
  return `${item.days_quiet} day${item.days_quiet === 1 ? '' : 's'} quiet`
}
